export class TokenError extends Error {
  static isInstance(error) {
    return error instanceof this;
  }

  constructor(code, message = 'Token Error') {
    super(message);
    this.code = code;
  }
}

TokenError.ERROR_CODE_TOKEN_INVALID = 'ERROR_CODE_TOKEN_INVALID';
TokenError.ERROR_CODE_TOKEN_EXPIRED = 'ERROR_CODE_TOKEN_EXPIRED';

export class TokenInvalidError extends TokenError {
  constructor() {
    super(TokenError.ERROR_CODE_TOKEN_INVALID, 'Token Invalid');
  }
}

export class TokenExpiredError extends TokenError {
  constructor() {
    super(TokenError.ERROR_CODE_TOKEN_EXPIRED, 'Token Expired');
  }
}
